import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "iletisim";
var iletisimService = {


    onsiparisDetay(siparisKodu) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                siparisKodu: siparisKodu,
                methodName: "onSiparisDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    onsiparisArsiv(siparisKodu) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                siparisKodu: siparisKodu,
                methodName: "onSiparisArsiv"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    onSiparisList(durum, baslangic, limit) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                methodName: "onSiparisList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },



    iletisimDetay(iletisimId) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimDetay"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimArsiv(iletisimId) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                iletisimId: iletisimId,
                methodName: "iletisimArsiv"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimList(durum, baslangic, limit) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                methodName: "iletisimList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimAyarTanimlama(ayarAdi, mail, sms) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                ayarAdi: ayarAdi,
                mail: mail,
                sms: sms,
                methodName: "iletisimAyarTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimAyarList() {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                methodName: "iletisimAyarList"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    iletisimAyarGuncelle(ayarKodu, mail, sms) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                ayarKodu: ayarKodu,
                mail: mail,
                sms: sms,
                methodName: "iletisimAyarGuncelleme"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    onsiparisNot(siparisKodu, not) {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                siparisKodu: siparisKodu,
                not: not,
                methodName: "onSiparisNotuEkle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
};
export default iletisimService

